<template>
	<div class="boxWid d-cw d-aie d-jcc">
		<!-- 上部分 -->
		<div class="Ttop d-rn d-aic d-jcb">
			<ul class="Ttop-lftImg">
				<img src="../assets/img/comm/icon_logoLeft.png" >
			</ul>
			<ul class="Ttop-shBox d-rn d-aic d-jce">
				<input type="text" class="d-rn d-aic d-jcs" placeholder="请输入要搜索的信息"
				 ref="input_topSh" @keyup.enter="handleShVal" v-model="searchVal"/>
				<p class="showHand noSelectBox" @click="throttle(handleShVal,1500)">搜索</p>
			</ul>
		</div>
		<!-- 热门搜索 -->
		<ul class="hotSh d-rn d-aic d-jcs" v-show="hotState">
			<li class="boxNoYs hotSh-firstLi">热门搜索：</li>
			<li class="hotSh-rgtLi one-txt-cut">
				<p :class="['hotSh-itemP','noSelectBox','boxNoYs','one-txt-cut',index!=3?'hotSh-itemPA':'',index?'hotSh-itemPadLft':'','showHand']"
				v-for="(item,index) in hotShArr" :key='index' @click="throttle(handleSelHotVal,1500,item)">{{item.hotSearchContent}}</p>
			</li>
		</ul>
		
	</div>
</template>

<script>
	let _self;
	export default {
		data() {
			return {
				// 搜索信息
				searchVal:null,
				
				// 搜索状态
				shState:true,
				// 热门搜索记录
				hotShArr:null,
			}
		},
		props:{
			ssTxt:{
				type:String,
				default:''
			},
			hotState:{
				type:Boolean,
				default:true
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			
			
			// 事件监听===
			_self.handleAllEvents()
		},
		// 方法集
		methods: {
			// 事件监听
			handleAllEvents(){
				// 监听热门搜索接口返回值
				_self.$EventBus.$on('hotSearchArr',res=>{
					// console.log('组件===》热门历史搜索',res);
					
					// 定义热门搜索记录
					_self.hotShArr=res;
				})
				
				// 监听搜索接口是否请求完毕
				_self.$EventBus.$on('newTpShState',val=>{
					// console.log('搜索状态====',val);
					
					// 定义状态===是否允许搜索
					_self.shState=val;
				})
			},
			
			
			// 回车开始搜索事件
			handleShVal(){
				// 判断请求状态
				// console.log('请求状态===》回车',_self.shState);
				if(!_self.shState){
					_self.$jgTips('正在搜索中，请稍等')
					return false;
				}
				_self.shState=false;
				
				// 使input脱离光标===
				this.$nextTick(()=>{
				    this.$refs.input_topSh.blur();
				})
				
				// 判断是否输入为空
				let newTxt=_self.$commonFun.delTxtLrK(_self.searchVal || '');
				if(!newTxt)return ;
				
				// 修改页码数
				_self.$EventBus.$emit('editPageCrt',1)
				
				// decodeURIComponent
				// 编码encodeURIComponent()
				let pageVal=encodeURIComponent(JSON.stringify({pageType:1,pageVal:_self.searchVal}));
				// 跳转到搜索页面并传递搜索信息
				_self.$router.push({path:'/ShopList',query:{searchVal:pageVal}})
				
				// console.log('组件====》传递搜索');
				// 接口请求完毕
				_self.$EventBus.$emit('shopListData',_self.searchVal)
			},
			// 热门搜索选择
			handleSelHotVal(item,index){
				// 判断请求状态
				// console.log('热门搜索状态====',_self.shState);
				if(!_self.shState){
					_self.$jgTips('正在查询中，请稍等')
					return false;
				}
				
								
				// 定义搜索信息
				_self.searchVal=item.hotSearchContent;
				// 搜索事件
				_self.handleShVal();
			}
		},
		// 组件集
		components:{

		},
		mounted() {
			// console.log('定义搜索信息');
			_self.searchVal=_self.ssTxt;
		},
		watch:{
			
		},
		computed:{
		
		},
		// 过滤器
		filters:{
			
		},
		// 实例销毁
		destroyed(){
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>
<style lang="scss">
	/* 上部分 */
	.Ttop{
		width: 100%;
		/* logo */
		&-lftImg{
			width: 190px;
			height: 66px;
			img{
				width: 100%;
				height: 100%;
			}
		}
		/* 搜索框 */
		&-shBox{
			width: 900px;
			input{
				flex: 1;
				height: 56px;
				background: #ffffff;
				border: 2px solid #e62129;
				border-radius: 4px 0 0 4px;
				padding: 0 20px;
				box-sizing: border-box;
				
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #333333;
				letter-spacing: 2px;
			}
			p{
				width: 160px;
				height: 56px;
				background: #e62129;
				border-radius: 0px 4px 4px 0px;
				
				font-size: 20px;
				font-weight: 400;
				text-align: center;
				line-height: 56px;
				color: #ffffff;
				letter-spacing: 2px;
			}
		}
	}
	/* 下部分==热门搜索 */
	.hotSh{
		width: 900px;
		box-sizing: border-box;
		overflow: hidden;
		&-firstLi{
			font-size: 18px;
			font-weight: 400;
			text-align: left;
			color: #666666;
			letter-spacing: 2px;
		}
		
		/* 搜索内容 */
		&-rgtLi{
			flex: 1;
			padding-right: 10px;
			box-sizing: border-box;
		}
		&-itemP{
			display: inline-block;
			font-size: 18px;
			font-weight: 400;
			text-align: left;
			color: #999999;
			letter-spacing: 2px;
		}
		/* 横线 */
		&-itemPA::after{
			content: '|';
			margin-left: 20px;
		}
		/* 左边距 */
		&-itemPadLft{
			padding-left: 10px;
			box-sizing: border-box;
		}
	}
	
	
	
	.boxWid{
		width: 1200px;
		margin: 0 auto;
		padding: 40px 0 25px;
		box-sizing: border-box;
	}
</style>
